import React, { useEffect, useState, useCallback, useRef } from 'react';
import moment from 'moment-timezone';
import {Box,Typography,Grid, Divider,useTheme} from '@mui/material';
import CircularProgressLoader from "../components/CircularProgressLoader";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonComponent from "../components/ButtonComponent";
import dashIcon from '../assets/images/dash_icon.png';
import LockerBankIcon from '../assets/images/LockerBankIcon.png';
import { LockerItemWithDetails } from '../components/LockerItemWithDetails';
import { BadgeComponent } from '../components/BadgeComponent';
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from '../lib/BrowserStorageAccessMiddleware';
import { 
  LOCAL_STORAGE, 
  SESSION_STORAGE, 
  LS_DOMAIN_AND_LOCKER_BANK, 
  LS_LOCKER_BANK_INFO, 
  LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, 
  USER_INFO, 
  SS_PAYMENT_GATEWAY, 
  SS_PAYMENT_GATEWAY_ACCESS_KEY, 
  LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, 
  LS_PROP_LOCKER_UNIT_DETAILS, 
  LS_IS_OPEN_WITH_CHECKOUT_AFTER_OVERSTAY_PAYMENT, 
  CURRENT_SLOT,
  DIFFERENTIAL,
  HOURLY,
  LOWEST_PAYMENT, 
  USER_LOCATION_DETAILS,
  PERMISSIONS_LIST
} from '../assets/constants/BrowserStorageKeys';

import { 
  getAssignedLockerList, 
  openLocker, 
  releaseLockerOfPickUpUser, 
  getTenantAndAssignmentSettings, 
  overduePayment, 
  fetchPaymentStatus, 
  cancelDropOffTransaction,
  UpdateUserProfile 
} from '../api/api';

import { 
  DYNAMIC_USE_CASE, 
  LUGGAGE_USE_CASE, 
  RETURN, 
  SUCCESS, 
  TOAST_SUCCESS, 
  TOAST_ERROR, 
  ERROR, 
  PENDING, 
  ASSIGNED, 
  COD, 
  REDIRECT, 
  BUTTON_PRIMARY, 
  BUTTON_WARNING, 
  REGEXP_EMAIL,
  HH_mm_ss
} from '../assets/constants/Constants';

import { 
  HOME, 
  LOCKER_SIZE_SELECTION, 
  PAYMENT_GATEWAY, 
  LOCKER_OPENED, 
  USER_ACCOUNT 
} from '../assets/constants/PageList';

import { 
  devConsoleLog, 
  getPathForNextPage, 
  convertDurationStringToMilliseconds, 
  convertMillisecondsToSpecifiedTimeFormat, 
  buildFinalGSTObject,
  extractPageNumber, 
  arePaymentGatewayAndAccessKeyValid, 
  verifyUserProximity, 
  GetAvailableLockerSizesAndRedirectUser,
  isUserEligibleForAssignment,
  isUserDetailsDialogShown,
  markUserDetailsDialogNotShown,
  hasLockerTimingCount,
  isLockerBlockedForNonOperationalBank,
  getUnitLabelParams,
  isPodBankType
} from '../lib/Utils';
import CustomDialog from '../components/CustomDialog';
import ShowToast from '../components/ToastComponent';
import { prePaymentRegistration } from '../lib/BackendUtils';
import {
    fetchNearbyLockersForLocation,
    getCurrentBrowserLocation,
    getNearbyLockerErrorMessage,
} from '../lib/NearbyLockerUtils';
import UserDetailsDialog from '../components/UserDetailsDialog';
import getSymbolFromCurrency from 'currency-symbol-map';

const MyLockeListPage = () => {
    const history = useHistory();
    const { t } = useTranslation();
    moment.tz.setDefault('Asia/Kolkata');
    const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
    const userId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO)?.id;
    const isAssignmentPricingEnabled = settings?.is_pricing;
    const gracePeriodInMilliseconds = (settings?.grace_period) ? convertDurationStringToMilliseconds(settings?.grace_period) : 0;
    const counterRef = useRef(null);
    const [expandedLockerRefId, setExpandedLockerRefId] = useState(null);
    const [collapsedLockerRefIds, setCollapsedLockerRefIds] = useState([]);
    const isInitialGetAssignedLockersDoneRef = useRef(false);
    const [lockerList, setLockerList] = useState([]);
    const [selectedLockerItemForOverstayPayment, setSelectedLockerItemForOverstayPayment] = useState({});
    const [isOpenWithCheckoutAfterOverstayPayment, setIsOpenWithCheckoutAfterOverstayPayment] = useState(false);
    const [selectedBookingSlotForOverstayPayment, setSelectedBookingSlotForOverstayPayment] = useState({});
    const [selectedOverduePayMethodForPayment, setSelectedOverduePayMethodForPayment] = useState('');
    const [amountToBePaidForOverstay, setAmountToBePaidForOverstay] = useState(0);
    const [overstayPaymentBreakdown, setOverstayPaymentBreakdown] = useState({
        baseAmount: 0,
        totalAmount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        igstAmount: 0,
        isStateGst: false,
        collectGst: false,
        currencyCode: 'INR',
    });
    const [isOverstayPaymentModalVisible, setIsOverstayPaymentModalVisible] = useState(false);
    const [userProximityError, setUserProximityError] = useState('');
    const [isUserProximityErrorModalVisible, setIsUserProximityErrorModalVisible] = useState(false);
    const [active, setActive] = useState(false);
    const [assignLockerror, setAssignLockerror] = useState(false);
    const [message, setMessage] = useState({});
    const [originalLockerList, setOriginalLockerList] = useState([]);
    const [returnedLockersList, setReturnedLockersList] = useState([]);
    const [returnFilteredList, setReturnFilteredList] = useState([]);
    const [extraFeatureEnabled, setExtraFeatureEnabled] = useState(false);
    const [hasReturnedLockers, setHasReturnedLockers] = useState(false);
    const [hasDataInSearch, setHasDataInSearch] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [itemPerPage, setItemPerPage] = useState(0);
    const [loadingMessage, setLoadingMessage] = useState(isAssignmentPricingEnabled ? t('Getting_Lockers', getUnitLabelParams(lockerBankInfo?.LockerBankType, t)) : '');
    const [nextPageUrl, setNextPageUrl] = useState('');
    const [hasNextPageForSearch,setHasNextPageForSearch] = useState(false);
    const [filteredLockers, setFilteredLockers] = useState([]);
    const [isSearchComplete,setIsSearchComplete] = useState(false);
    const [hasPendingLockers, setHasPendingLockers] = useState(0);
    const prevSearchTextRef = useRef();
    const [hasMore, setHasMore] = useState(false);
    const scrollContainerRef = useRef(null);
    const [page,setPage] = useState(1);
    const [count,setCount] = useState(0);
     // Refs to keep track of the latest values
    const hasMoreRef = useRef(hasMore);
    const nextPageUrlRef = useRef(nextPageUrl);
    const pageRef = useRef(page);
    const theme = useTheme();
    const colorScheme = theme.palette.mode;
    const overdue_pay_method = settings?.overdue_pay_method;
    const [isOpenWithCheckoutButtonClicked, setIsOpenWithCheckoutButtonClicked] = useState(false);
    const skipPaymentStatusCheckRef = useRef(history.location?.state?.skipPaymentStatus === true);

    const [isLoading, setLoaderDisabled] = useState(isAssignmentPricingEnabled  ? true : false);
    const [showQRCodeReader, setShowQRCodeReader] = useState(false)

    const LoadersetON = () => {
        setLoaderDisabled(true);
    };
    const LoadersetOFF = () => {
        setLoaderDisabled(false);
    };
    /*
    user related code for showing user details dialog and getting user details before locker assignment 
    */
    const getStoredUserDetails = () => {
        const storedUserInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO) || {};

        return {
            first_name: storedUserInfo?.first_name || '',
            last_name: storedUserInfo?.last_name || '',
            username: storedUserInfo?.username || '',
            email: storedUserInfo?.email || '',
            mobile_number: storedUserInfo?.mobile_number || '',
        };
    };

    const [userDetails, setUserDetails] = useState(() => getStoredUserDetails());
    const [isUserDetailsDialogOpen, setIsUserDetailsDialogOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [submitAttempted, setSubmitAttempted] = useState(false);

    const validateUserDetails = (details) => {
        const errors = {};
        if (!details.first_name?.trim()) {
        errors.first_name = t('Error_First_name_required');
        }
        if (!details.last_name?.trim()) {
        errors.last_name = t('Error_Last_name_required');
        }
        if (!details.email?.trim()) {
        errors.email = t('Error_Email_required');
        } else if (!REGEXP_EMAIL.test(details.email)) {
        errors.email = t('LoginEmailError');
        }
        return errors;
    };

    const handleSubmitUserDetails = async() => {
        setSubmitAttempted(true);

        const errors = validateUserDetails(userDetails);

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        try {
            const normalizedMobileNumber = `${userDetails.mobile_number || ''}`.replace(/^\+/, '');
            const payload = {
                ...userDetails,
                mobile_number: normalizedMobileNumber,
            };
            const data = await UpdateUserProfile(payload);
            if (data?.status === SUCCESS) {
                const existingUserInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, USER_INFO) || {};
                const updatedUserInfo = {
                    ...existingUserInfo,
                    ...userDetails,
                    mobile_number: normalizedMobileNumber ? `+${normalizedMobileNumber}` : '',
                };

                storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, USER_INFO, updatedUserInfo);
                setUserDetails(getStoredUserDetails());
                markUserDetailsDialogNotShown();
                ShowToast(t('Success_User_Details_Update'), TOAST_SUCCESS);
                setIsUserDetailsDialogOpen(false);
                setFormErrors({});
                setSubmitAttempted(false);
                return;
            }

            ShowToast(t(data?.message || 'something_went_wrong_text'), TOAST_ERROR);
        } catch (error) {
            console.error('Failed to update user details from MyLockeListPage: ', error);
            ShowToast(t('something_went_wrong_text'), TOAST_ERROR);
        }
    };
    const handleChangeUserDetails = (field, value) => {
        setUserDetails((prev) => ({
        ...prev,
        [field]: value,
        }));

        setFormErrors((prev) => ({
        ...prev,
        [field]: '',
        }));
    };

    const handleCloseUserDetailsDialog = () => {
        setIsUserDetailsDialogOpen(false);
        setUserDetails(getStoredUserDetails());
        setFormErrors({});
        setSubmitAttempted(false);
        markUserDetailsDialogNotShown()
    };

    const toggleLockerAccordionState = (lockerItem) => {

        if (lockerItem?.locker_door?.is_blocked) {
            ShowToast(t('Warnning_Locker_Blocked', getUnitLabelParams(lockerItem?.locker_bank?.bank_type, t)), TOAST_ERROR);
            return;
        }
        else if(settings?.usecase_settings?.restrict_locker_operation_on_pwa?.value){
                const isOverdue = lockerItem?.isOverstay && lockerItem.overstayDurationInMilliseconds > gracePeriodInMilliseconds;
                ShowToast(t(isOverdue ? 'text_please_complete_overdue_payment_from_tab' : 'text_please_open_locker_from_tab', getUnitLabelParams(lockerItem?.locker_bank?.bank_type, t)), TOAST_ERROR);
                 return;
            }
        else if (isLockerBlockedForNonOperationalBank(lockerItem?.locker_bank?.bank_type, getSecureItemFromSpecificStorage(LOCAL_STORAGE, PERMISSIONS_LIST))) {
            ShowToast(t('Warning_Locker_No_Access_Contact_Admin', getUnitLabelParams(lockerItem?.locker_bank?.bank_type, t)), TOAST_ERROR);
            return;
        }

        if (isLockerAccordionExpanded(lockerItem)) {
            if (expandedLockerRefId === lockerItem.ref_id) {
                setExpandedLockerRefId(null);
            }
            setCollapsedLockerRefIds(prev => [...prev, lockerItem.ref_id]);
        }
        else {
            setExpandedLockerRefId(lockerItem.ref_id);
            setCollapsedLockerRefIds(prev => prev.filter(refId => refId !== lockerItem.ref_id));
        }
    };

    // Locker never opened yet (open count 0): keep accordion expanded by default to show open & invoice buttons, unless user collapsed it
    const isLockerExpandedByDefault = (lockerItem) => {
        return (
            isAssignmentPricingEnabled &&
            lockerItem?.is_already_opened_once === false &&
            !lockerItem?.locker_door?.is_blocked &&
            !settings?.usecase_settings?.restrict_locker_operation_on_pwa?.value &&
            !isLockerBlockedForNonOperationalBank(lockerItem?.locker_bank?.bank_type, getSecureItemFromSpecificStorage(LOCAL_STORAGE, PERMISSIONS_LIST)) &&
            !collapsedLockerRefIds.includes(lockerItem?.ref_id)
        );
    };

    const isLockerAccordionExpanded = (lockerItem) => {
        return expandedLockerRefId === lockerItem?.ref_id || isLockerExpandedByDefault(lockerItem);
    };
/* useEffect #1 (declared first; runs first after render when triggered) - usage timer refresher
   - Guards: returns early if assignment pricing is disabled OR lockerList is empty.
   - Side effects: clears any previous interval, then starts a 1s interval.
   - Functions called:
     - moment() to get current time.
     - setLockerList(...) to update locker state.
     - convertMillisecondsToDaysHoursMinutesSecondsFormat(...) to format the display time.
     - clearInterval(...) for cleanup.
   - State updated:
     - lockerList (per-locker fields updated below)
       - totalUsageTimeInMilliseconds
       - remainingBookingDurationInMilliseconds
       - overstayDurationInMilliseconds
       - usageTime (formatted string)
       - isOverstay (boolean)
   - Cleanup: clears the interval on unmount or when lockerList.length changes.
   besically it is going to check either pricing is enabled or not if it is enabled 
   then it will check for the assigned lockers and then it will calculate the usage time 
   and remaining time for each locker and it will update the locker list every second 
   to show the updated usage time and remaining time for each locker. 
*/
    useEffect(() => {
        if ( !isAssignmentPricingEnabled || lockerList.length === 0) {
            return;
        }

        if (counterRef.current) {
            clearInterval(counterRef.current);
        }

        counterRef.current = setInterval(() => {
            const currentTime = moment();

            setLockerList((prevLockerList) => {
                return prevLockerList.map((locker) => {
                    if (locker?.selected_size_pricing?.id && locker?.status === 'assigned') {
                        const assignedDateAndTime = moment(locker?.assigned_date);
                        const usageTimeInMilliseconds = currentTime.diff(assignedDateAndTime);
                        // changed due to Pod work
                        const timerBookingDurationInMilliseconds = locker.totalBookingDurationInMilliseconds || locker.timerBookingDurationInMilliseconds;
                        const remainingBookingDurationInMilliseconds = (usageTimeInMilliseconds <= timerBookingDurationInMilliseconds) ? (timerBookingDurationInMilliseconds - usageTimeInMilliseconds) : 0;
                        const overstayDurationInMilliseconds = (usageTimeInMilliseconds > timerBookingDurationInMilliseconds) ? (usageTimeInMilliseconds - timerBookingDurationInMilliseconds) : 0;
                        const isOverstay = overstayDurationInMilliseconds > 0 ? true : false;

                        const formattedUsageTime = convertMillisecondsToDaysHoursMinutesSecondsFormat(isOverstay ? overstayDurationInMilliseconds : remainingBookingDurationInMilliseconds);

                        return {
                            ...locker,
                            totalUsageTimeInMilliseconds: usageTimeInMilliseconds,
                            remainingBookingDurationInMilliseconds,
                            overstayDurationInMilliseconds,
                            usageTime: formattedUsageTime,//moment(usageTimeInMilliseconds).format('HH:mm:ss'),
                            isOverstay
                        }
                    }

                    return locker;
                });
            });
        }, 1000);

        return () => {
            if (counterRef.current) {
                clearInterval(counterRef.current);
            }
        }
    }, [lockerList.length]);

    const checkIfOverstay = (selectedDurationInMilliseconds, gracePeriodInMilliseconds, usageTimeInMilliseconds) => {
        return (usageTimeInMilliseconds < (selectedDurationInMilliseconds + gracePeriodInMilliseconds)) ? false : true;
    };

    const convertMillisecondsToDaysHoursMinutesSecondsFormat = (milliseconds) => {
        let seconds = Math.floor(milliseconds / 1000);
        let minutes = Math.floor(seconds / 60);
        let hours = Math.floor(minutes / 60);
        let days = Math.floor(hours / 24);

        seconds %= 60;
        minutes %= 60;
        hours %= 24;

        const formattedDays = days.toString().padStart(1, '0');
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        return `${formattedDays} d : ${formattedHours} h : ${formattedMinutes} m : ${formattedSeconds} s`;
    };

    const getAssignedLockersAndCheckPaymentStatus = async () => {
        try {
            let getAssignedLockersResponse = await getAssignedLockers(settings.id);
            let assignedLockerList = Array.isArray(getAssignedLockersResponse?.data) ? getAssignedLockersResponse.data : [];
            devConsoleLog('assigned locker list: ', assignedLockerList);

            const skipPaymentStatusCheck = skipPaymentStatusCheckRef.current;
            if (skipPaymentStatusCheckRef.current) {
                skipPaymentStatusCheckRef.current = false;
            }

            const shouldRefetchUpdatedAssignedLockersList = skipPaymentStatusCheck
                ? false
                : await checkPaymentStatusOfPendingReservationsAndOverstayTransactions(assignedLockerList);
            devConsoleLog('Should refetch updated assigned lockers list?', shouldRefetchUpdatedAssignedLockersList);

            if (shouldRefetchUpdatedAssignedLockersList) {
                getAssignedLockersResponse = await getAssignedLockers(settings.id);
                assignedLockerList = Array.isArray(getAssignedLockersResponse?.data) ? getAssignedLockersResponse.data : [];
            }

            const updatedLockerList = calculateTotalBookingDurationForEachLocker(assignedLockerList);
            devConsoleLog('updated locker list with amount paid and booking duration: ', updatedLockerList);
            setLockerList(updatedLockerList);
        } catch (error) {
            console.error('Error while processing assigned lockers in pricing mode: ', error);
            setLockerList([]);
        } finally {
            setLoaderDisabled(false);
        }
    };

    const getAssignedLockers = async (assignmentId, searchText = '', pageNumber = 1) => {
        try {
            const getAssignedLockerListResponse = await getAssignedLockerList(assignmentId, searchText, pageNumber);

            if (getAssignedLockerListResponse?.status === SUCCESS) {
                return getAssignedLockerListResponse; 
            }
        } catch (error) {
            console.error('Error while fetching assigned lockers list: ', error);
            return [];
        }
    };

    const checkPaymentStatusOfPendingReservationsAndOverstayTransactions = async (assignedLockerList) => {
        const paymentStatusCheckPromises = [];
        let shouldRefetchUpdatedAssignedLockersList = false;

        for (const locker of assignedLockerList) {
            if (locker.status === 'pending') {
                shouldRefetchUpdatedAssignedLockersList = true;
                paymentStatusCheckPromises.push(checkPaymentStatusAndCancelPendingReservation(locker));
            }
            else if (locker.status === 'assigned') {
                for (const paymentRecord of (locker.payment_records || [])) {
                    if ((paymentRecord.payment_type === 'OVERDUE') && (paymentRecord.status !== 'completed') && (paymentRecord.status !== 'failed')) {
                        shouldRefetchUpdatedAssignedLockersList = true;
                        paymentStatusCheckPromises.push(checkPaymentStatus(paymentRecord.transaction_id, paymentRecord.payment_gateway));
                    }
                };
            }
        };

        if (paymentStatusCheckPromises.length > 0) {
            await Promise.all(paymentStatusCheckPromises);
        }

        return shouldRefetchUpdatedAssignedLockersList;
    };

    const checkPaymentStatusOfAssignedLockersWithCod = async (assignedLockersList) => {
        const paymentStatusCheckPromises = [];
        let shouldRefetchUpdatedAssignedLockersList = false;

        for (const locker of assignedLockersList) {
            if ((locker.status === ASSIGNED) && (locker.payment_type === COD)) {
                for (const paymentRecord of (locker.payment_records || [])) {
                    if ((paymentRecord.payment_type === 'PAYMENT') && (paymentRecord.status !== 'completed') && (paymentRecord.status !== 'failed')) {
                        shouldRefetchUpdatedAssignedLockersList = true;
                        paymentStatusCheckPromises.push(checkPaymentStatus(paymentRecord.transaction_id, paymentRecord.payment_gateway));
                    }
                };
            }
        };

        if (paymentStatusCheckPromises.length > 0) {
            await Promise.all(paymentStatusCheckPromises);
        }

        return shouldRefetchUpdatedAssignedLockersList;
    }

    const checkPaymentStatusAndCancelPendingReservation = async (locker) => {
        try {
            const isLockerReservationPaymentSuccessful = (locker.payment_records[0].status === 'failed') ? false : await checkPaymentStatus(locker.payment_records[0].transaction_id, locker.payment_records[0].payment_gateway);

            if (isLockerReservationPaymentSuccessful) {
                return true;
            }
            else if (isLockerReservationPaymentSuccessful === false) {
                const isReservationCancelled = await cancelPendingReservation(locker.ref_id, 'Cancel luggage locker reservation: Unsuccessful payment.');
                
                if (isReservationCancelled) {
                    devConsoleLog('Reservation cancelled for locker: ', locker?.locker_door?.door_no);
                }
                else {
                    devConsoleLog('Unable to cancel reservation for locker: ', locker?.locker_door?.door_no);
                }
            }

            return false;
        } catch (error) {
            console.error();
        }
    };

    const checkPaymentStatus = async (paymentTransactionId, paymentGateway) => {
         const skipPaymentStatusCheck = skipPaymentStatusCheckRef.current;
                if (skipPaymentStatusCheckRef.current) {
                    skipPaymentStatusCheckRef.current = false;
                }
        if ( skipPaymentStatusCheck || !paymentTransactionId || !paymentGateway) {
            return;
        }
        try {
            const fetchPaymentStatusResponse = await fetchPaymentStatus(paymentTransactionId, paymentGateway);
            
            if (fetchPaymentStatusResponse?.status === SUCCESS) {
                return fetchPaymentStatusResponse?.data?.is_paid;
            }
        } catch (error) {
            console.error('Error while fetching payment status: ', error);
            return undefined;
        }
    };

    const cancelPendingReservation = async (lockerReferenceId, cancellationReason) => {
        try {
            const cancelReservationResponse = await cancelDropOffTransaction(lockerReferenceId, cancellationReason);

            if (cancelReservationResponse?.status === SUCCESS) {
                return true;
            }
        } catch (error) {
            console.error('Error while cancelling pending reservation: ', error);
            return undefined;
        }
    };

    const getCompletedOverduePaymentRecords = (paymentRecords = []) => (
        paymentRecords.filter((paymentRecord) => paymentRecord.payment_type === 'OVERDUE' && paymentRecord.status === 'completed')
    );

    const getCompletedOverdueAmount = (paymentRecords = []) => (
        getCompletedOverduePaymentRecords(paymentRecords).reduce((accumulatedAmount, paymentRecord) => (
            accumulatedAmount + parseFloat(paymentRecord.base_amount || 0)
        ), 0)
    );


    const getCurrentSlotDurationFromAmount = (amount, selectedBookingSlot) => {
        const bookingDuration = selectedBookingSlot?.durationInMilliseconds || 0;
        const bookingAmount = parseFloat(selectedBookingSlot?.price || 0);

        return (bookingAmount && bookingDuration) ? (parseFloat(amount || 0) / bookingAmount) * bookingDuration : 0;
    };

    const getDifferentialDurationFromAmount = (amount, sizePricing, maxDurationBookingSlot) => {
        const parsedAmount = parseFloat(amount || 0);
        const maxDurationBookingSlotPrice = parseFloat(maxDurationBookingSlot?.price || 0);

        if (maxDurationBookingSlotPrice > 0 && parsedAmount > maxDurationBookingSlotPrice) {
            const numberOfFullMaxDurationSlots = Math.floor(parsedAmount / maxDurationBookingSlotPrice);
            const amountBeyondFullMaxDurationSlots = parsedAmount % maxDurationBookingSlotPrice;
            const bookingSlotToConsiderForRemainingAmount = sizePricing.find((slot) => amountBeyondFullMaxDurationSlots === parseFloat(slot.price));

            return (numberOfFullMaxDurationSlots * maxDurationBookingSlot.durationInMilliseconds)
                + (bookingSlotToConsiderForRemainingAmount?.durationInMilliseconds || 0);
        }

        const bookingSlotToConsiderBasedOnAmount = sizePricing.find((slot) => parsedAmount === parseFloat(slot.price));
        return bookingSlotToConsiderBasedOnAmount?.durationInMilliseconds || 0;
    };

    const getHourlyOverstayPricingDetails = (locker) => {
        const hourlyPriceObjectForSelectedSize = locker?.hourly_overdue_pricing?.[0];
        const hourlyPriceForSelectedSize = parseFloat(hourlyPriceObjectForSelectedSize?.price || 0);
        const hourlyDurationInMilliseconds = convertDurationStringToMilliseconds(hourlyPriceObjectForSelectedSize?.duration);

        return {
            hourlyPriceObjectForSelectedSize,
            hourlyPriceForSelectedSize,
            hourlyDurationInMilliseconds
        };
    };

    const getHourlyDurationFromAmount = (amount, locker) => {
        const { hourlyPriceForSelectedSize, hourlyDurationInMilliseconds } = getHourlyOverstayPricingDetails(locker);

        return (hourlyPriceForSelectedSize && hourlyDurationInMilliseconds)
            ? (parseFloat(amount || 0) / hourlyPriceForSelectedSize) * hourlyDurationInMilliseconds
            : 0;
    };

    /**
     * Gets the total covered duration from completed overdue payment records.
     *
     * `overdue_ref` is generated when an overstay payment is created and represents
     * the total duration covered from the locker assignment time. This value is more
     * reliable than deriving duration from `base_amount`, because some payment modes
     * charge only an incremental amount while still covering a larger rounded duration.
     *
     * @param {Array} paymentRecords Payment records attached to a locker transaction.
     * @returns {number} Covered duration in milliseconds, or 0 when no valid ref exists.
     */
    const getCompletedOverdueRefDuration = (paymentRecords = []) => {
        return getCompletedOverduePaymentRecords(paymentRecords).reduce((maxDuration, paymentRecord) => {
            if (!paymentRecord?.overdue_ref) {
                return maxDuration;
            }

            return Math.max(maxDuration, convertDurationStringToMilliseconds(paymentRecord.overdue_ref));
        }, 0);
    };

    const getLowestPaymentDurationFromCompletedRecords = (locker, sizePricing, maxDurationBookingSlot, selectedBookingSlot) => {
        return getCompletedOverduePaymentRecords(locker.payment_records || []).reduce((totalDuration, paymentRecord) => {
            const paymentAmount = parseFloat(paymentRecord.base_amount || 0);

            const overduePaymentType = paymentRecord?.overdue_type;
            if (overduePaymentType === CURRENT_SLOT) {
                return totalDuration + getCurrentSlotDurationFromAmount(paymentAmount, selectedBookingSlot);
            }

            if (overduePaymentType === DIFFERENTIAL) {
                return totalDuration + getDifferentialDurationFromAmount(paymentAmount, sizePricing, maxDurationBookingSlot);
            }

            if (overduePaymentType === HOURLY) {
                return totalDuration + getHourlyDurationFromAmount(paymentAmount, locker);
            }

            return totalDuration + Math.max(
                getCurrentSlotDurationFromAmount(paymentAmount, selectedBookingSlot),
                getDifferentialDurationFromAmount(paymentAmount, sizePricing, maxDurationBookingSlot),
                getHourlyDurationFromAmount(paymentAmount, locker)
            );
        }, 0);
    };

    const calculateTotalBookingDurationForEachLocker = (assignedLockerList) => {
        return assignedLockerList.map((locker) => {
            if (locker.status === 'assigned') {
                const sizePricing = Array.isArray(locker?.size_pricing) ? locker.size_pricing : [];
                sizePricing.forEach((slot) => {
                    slot.durationInMilliseconds = convertDurationStringToMilliseconds(slot.duration);
                });

                const incrementallySortedBookingSlots = sizePricing.slice().sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
                const maxDurationBookingSlot = incrementallySortedBookingSlots[incrementallySortedBookingSlots.length - 1];
                const selectedBookingSlotForTimer = sizePricing.find((slot) => slot.id === locker.selected_size_pricing.id);
                const timerBookingDurationInMilliseconds = selectedBookingSlotForTimer?.durationInMilliseconds || 0;
                let totalBookingDurationInMilliseconds = 0;

                const totalAmountPaid = (locker.payment_records || []).reduce((accumulatedAmount, paymentRecord) => {
                    if ( (paymentRecord.payment_type === 'PAYMENT' || paymentRecord.payment_type === 'OVERDUE'
                        || paymentRecord.payment_type === 'Bulk Reservation' || paymentRecord.payment_type === 'advance_booking') && (paymentRecord.status === 'completed')) {
                        return accumulatedAmount + parseFloat(paymentRecord.base_amount);
                    }
                    else {
                        return accumulatedAmount;
                    }
                }, 0);
                
                if (sizePricing.length === 0 || !locker?.selected_size_pricing?.id) {
                    return {
                        ...locker,
                        totalAmountPaid,
                        totalBookingDurationInMilliseconds
                    };
                }

                if(overdue_pay_method === CURRENT_SLOT){
                    
                    const bookingSlotToConsiderBasedOnTotalAmountPaid = sizePricing.find((slot) => slot.id === locker.selected_size_pricing.id);
                    totalBookingDurationInMilliseconds = bookingSlotToConsiderBasedOnTotalAmountPaid?.durationInMilliseconds || 0;
                    const bookingduration = bookingSlotToConsiderBasedOnTotalAmountPaid?.durationInMilliseconds || 0;
                    const amountforBookingDuration = bookingSlotToConsiderBasedOnTotalAmountPaid?.price || 0;
                    if (!amountforBookingDuration) {
                        return {
                            ...locker,
                            totalAmountPaid,
                            totalBookingDurationInMilliseconds
                        };
                    }
                    const slotsPaid = totalAmountPaid / amountforBookingDuration;
                    const latestDuration = bookingduration * slotsPaid;
                    totalBookingDurationInMilliseconds = latestDuration;
                }
                else if(overdue_pay_method === DIFFERENTIAL){
                    totalBookingDurationInMilliseconds = getDifferentialDurationFromAmount(
                        totalAmountPaid,
                        sizePricing,
                        maxDurationBookingSlot
                    );
                }
                else if(overdue_pay_method === HOURLY){
                    const selectedBookingSlot = sizePricing.find((slot) => slot.id === locker.selected_size_pricing.id);
                    const selectedBookingDurationInMilliseconds = selectedBookingSlot?.durationInMilliseconds || 0;
                    const hourlyPriceObjectForSelectedSize = locker?.hourly_overdue_pricing?.[0];
                    const hourlyPriceForSelectedSize = parseFloat(hourlyPriceObjectForSelectedSize?.price || 0);
                    const hourlyDurationInMilliseconds = convertDurationStringToMilliseconds(hourlyPriceObjectForSelectedSize?.duration);
                    const amountPaidForOverstay = getCompletedOverdueAmount(locker.payment_records || []);

                    const paidOverstayDurationInMilliseconds = (hourlyPriceForSelectedSize && hourlyDurationInMilliseconds)
                        ? (amountPaidForOverstay / hourlyPriceForSelectedSize) * hourlyDurationInMilliseconds
                        : 0;

                    totalBookingDurationInMilliseconds = selectedBookingDurationInMilliseconds + paidOverstayDurationInMilliseconds;
                }
                else if(overdue_pay_method === LOWEST_PAYMENT){
                    const selectedBookingSlot = sizePricing.find((slot) => slot.id === locker.selected_size_pricing.id);
                    const selectedBookingDurationInMilliseconds = selectedBookingSlot?.durationInMilliseconds || 0;
                    const paidOverstayDurationInMilliseconds = getLowestPaymentDurationFromCompletedRecords(
                        locker,
                        sizePricing,
                        maxDurationBookingSlot,
                        selectedBookingSlot
                    );

                    totalBookingDurationInMilliseconds = selectedBookingDurationInMilliseconds + paidOverstayDurationInMilliseconds;
                }
                devConsoleLog('total amount paid: ', totalAmountPaid);

                /*
                 * Prefer the backend-provided overdue reference when it exists.
                 * It represents the final covered duration from assignment time,
                 * while the amount-based calculation above is only a fallback for
                 * older records that do not have overdue_ref.
                 */
                const completedOverdueRefDurationInMilliseconds = getCompletedOverdueRefDuration(locker.payment_records || []);
                if (completedOverdueRefDurationInMilliseconds > 0) {
                    totalBookingDurationInMilliseconds = completedOverdueRefDurationInMilliseconds;
                }
                devConsoleLog('total booking duration in milliseconds: ', totalBookingDurationInMilliseconds);
                 // changed due to Pod work
                const coveredBookingDurationInMilliseconds = totalBookingDurationInMilliseconds || timerBookingDurationInMilliseconds;
                const assignedDateAndTime = moment(locker?.assigned_date);
                const usageTimeInMilliseconds = assignedDateAndTime.isValid() ? Math.max(moment().diff(assignedDateAndTime), 0) : 0;
                const remainingBookingDurationInMilliseconds = (usageTimeInMilliseconds <= coveredBookingDurationInMilliseconds)
                    ? (coveredBookingDurationInMilliseconds - usageTimeInMilliseconds)
                    : 0;
                const overstayDurationInMilliseconds = (usageTimeInMilliseconds > coveredBookingDurationInMilliseconds)
                    ? (usageTimeInMilliseconds - coveredBookingDurationInMilliseconds)
                    : 0;
                const isOverstay = overstayDurationInMilliseconds > 0;
                const usageTime = (coveredBookingDurationInMilliseconds > 0)
                    ? convertMillisecondsToDaysHoursMinutesSecondsFormat(isOverstay ? overstayDurationInMilliseconds : remainingBookingDurationInMilliseconds)
                    : '';

                return {
                    ...locker,
                    totalAmountPaid,
                    totalBookingDurationInMilliseconds,
                    timerBookingDurationInMilliseconds,
                    totalUsageTimeInMilliseconds: usageTimeInMilliseconds,
                    remainingBookingDurationInMilliseconds,
                    overstayDurationInMilliseconds,
                    usageTime,
                    isOverstay
                };
            }
            else {
                return locker;
            }
        });
    };

    const filterLockersWithPendingStatus = (lockerList) => lockerList?.filter(locker => locker.status === PENDING);

    const filterLockersWithReturnedStatus = (lockerList) => lockerList?.filter(locker => locker.status === RETURN);

    const filterAllLockersWithoutReturnedStatus = (lockerList) => lockerList?.filter(locker => locker.status !== RETURN);

    /* useEffect #2 (declared second; runs after #1 when triggered) - returned lockers flag
        - Trigger: whenever returnedLockersList.length changes.
        - Behavior: if there is at least one returned locker, flip hasReturnedLockers to true.
        - State updated:
            - hasReturnedLockers (only set to true; never set back to false here).
    */
    useEffect(() => {
        if (returnedLockersList.length > 0) {
            setHasReturnedLockers(true);
        }
    }, [returnedLockersList.length]);

    const resetAllLockerRelatedInfoInBetweenSearches = () => {
        setLockerList([]);
        setHasPendingLockers([]);
        setHasReturnedLockers(false);
        setReturnedLockersList([]);
        setFilteredLockers([]);
        setReturnFilteredList([]);
        setExtraFeatureEnabled(false);
    }

    const getLockerInfo = async (searchText,page = 1) => {
        try {
            if (page === 1) {
                setLockerList([]);
                setFilteredLockers([])
            }
            if (settings) {
                try {
                    let assignLockerList = await getAssignedLockers(settings.id, searchText, page);
                    devConsoleLog('assigned locker list: ', assignLockerList);

                    const skipPaymentStatusCheck = skipPaymentStatusCheckRef.current;
                    if (skipPaymentStatusCheckRef.current) {
                        skipPaymentStatusCheckRef.current = false;
                    }

                    const shouldRefetchUpdatedAssignedLockersList = skipPaymentStatusCheck
                        ? false
                        : await checkPaymentStatusOfAssignedLockersWithCod(assignLockerList?.data.length > 0 ? assignLockerList.data : []);
                    devConsoleLog('should refetch updated assigned lockers list? ', shouldRefetchUpdatedAssignedLockersList);

                    if (shouldRefetchUpdatedAssignedLockersList) {
                        assignLockerList = await getAssignedLockers(settings.id, searchText, page);
                    }

                    if (assignLockerList?.data.length > 0) {
                        assignLockerList = loopAndFlagAssignedLockersWithPendingPayment(assignLockerList);
                    }

                    devConsoleLog('updated locker list: ', assignLockerList);

                    if (assignLockerList?.status === SUCCESS) {
                        setActive(false);
                        setAssignLockerror(false);
                        if (assignLockerList.next) {
                            setHasMore(true);
                            setNextPageUrl(assignLockerList.next);
                        } else {
                            setHasMore(false);
                            setNextPageUrl('');
                        }
                        setItemPerPage(assignLockerList?.item_per_page);
                        const hasPendingLockers = filterLockersWithPendingStatus(assignLockerList.data); //.filter(locker => locker.status === PENDING);
                        setHasPendingLockers(hasPendingLockers);
                        const returnedLockers = filterLockersWithReturnedStatus(assignLockerList.data); //.filter(locker => locker.status === RETURN);
                        setReturnedLockersList(prevList => [...prevList, ...returnedLockers]);
                        const assignedLockers = filterAllLockersWithoutReturnedStatus(assignLockerList.data); //.filter(locker => locker.status !== RETURN);
                        setLockerList(prevList => [...prevList, ...assignedLockers]);
                        const extraFeatureEnabled = (hasPendingLockers?.length > 0) ? true : false; //assignLockerList.data.some(item => item.status ===  PENDING);
                        setExtraFeatureEnabled(extraFeatureEnabled);
                        if ((searchText === undefined || searchText === '') && page === 1) {
                            setCount(assignLockerList?.count)
                            setOriginalLockerList(assignLockerList.data);
                        }
                    } else {
                        setActive(assignLockerList === false);
                        setMessage({ maintext: t('InternalServerText'), subtext: '' });
                        setAssignLockerror(assignLockerList === null);
                    }
                } catch (error) {
                    setMessage({ maintext: t('ServerTimeout') });
                    setAssignLockerror(true);
                    console.error('getMyLockerList error', error);
                }
            }
        } catch (error) {
            console.error('getLockerInfo getMyLockerList try catch = ', error);
        }
    }



    /**
     * Retrieves locker information after performing a search.
     * 
     * @param {string} searchText - The text to search for.
     * @param {number} [page=1] - The page number to retrieve.
     * @returns {Promise<void>} - A promise that resolves when the locker information is retrieved.
     * @throws {Error} - If an error occurs while retrieving the locker information.
     */
    const getLockerInfoAfterSearch = async (searchText, page = 1) => {
        try {
            if (searchText.length > 0) {
                setFilteredLockers([]);
                setReturnFilteredList([]);
            }
            if (settings) {
                let assignLockerList = await getAssignedLockers(settings.id, searchText, page);
                devConsoleLog('assigned locker list after search: ', assignLockerList);

                const skipPaymentStatusCheck = skipPaymentStatusCheckRef.current;
                if (skipPaymentStatusCheckRef.current) {
                    skipPaymentStatusCheckRef.current = false;
                }

                const shouldRefetchUpdatedAssignedLockersList = skipPaymentStatusCheck
                    ? false
                    : await checkPaymentStatusOfAssignedLockersWithCod(assignLockerList?.data.length > 0 ? assignLockerList.data : []);
                devConsoleLog('should refetch updated assigned lockers after search? ', shouldRefetchUpdatedAssignedLockersList);

                if (shouldRefetchUpdatedAssignedLockersList) {
                    assignLockerList = await getAssignedLockers(settings.id, searchText, page);
                }

                if (assignLockerList?.data.length > 0) {
                    assignLockerList = loopAndFlagAssignedLockersWithPendingPayment(assignLockerList);
                }

                devConsoleLog('updated locker list after search: ', assignLockerList);
                
                if (assignLockerList) {
                    setActive(false);
                    setAssignLockerror(false);
                    if (assignLockerList.next) {
                        setHasNextPageForSearch(assignLockerList.next);
                    } else {
                        setHasNextPageForSearch(false);
                    }
                    setIsSearchComplete(true);
                    const assignedLockers = filterAllLockersWithoutReturnedStatus(assignLockerList.data); 
                    setFilteredLockers(assignedLockers);
                    assignLockerList.data.length > 0 && setHasDataInSearch(true);
                    const returnedLockers = filterLockersWithReturnedStatus(assignLockerList.data); 
                    setHasReturnedLockers( (returnedLockers?.length > 0) ? true : false );
                    setReturnFilteredList(returnedLockers);
                    const extraFeatureEnabled = assignLockerList.data.some(item => item.status === PENDING);
                    setExtraFeatureEnabled(extraFeatureEnabled);
                    devConsoleLog('length', returnedLockers?.length, returnedLockers?.length > 0);
                } else {
                    setActive(assignLockerList === false);
                    setMessage({ maintext: t('InternalServerText'), subtext: '' });
                    setAssignLockerror(assignLockerList === null);
                }
            }
        } catch (error) {
            setIsSearchComplete(true);
            console.error('getLockerInfo getMyLockerList try catch = ', error);
        }
    }

    const loopAndFlagAssignedLockersWithPendingPayment = (lockerList) => {
        const updatedLockerListData = lockerList.data.map((locker) => {
            if ((locker.status === 'assigned') && (locker.payment_type === 'cod')) {
                const isCodPaymentDone = locker.payment_records.some(paymentRecord => (paymentRecord.payment_type === 'PAYMENT' && paymentRecord.status === 'completed'));

                return {
                    ...locker,
                    isCodPaymentPending: !isCodPaymentDone
                };
            }

            return locker;
        });

        return {
            ...lockerList,
            data: updatedLockerListData
        };
    }


    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(() => {
            func(...args);
          }, delay);
        };
      };

    const debouncedGetLockerInfo = useCallback(debounce((text) => {
        getLockerInfoAfterSearch(text);
    }, 500), []);

    /**
     * Handles searching for a user in the local locker list.
     */
    const handleSearchUserInLocal = () => {
        try {
            const filtered = originalLockerList.filter((locker) =>
                locker?.client_ref?.toLowerCase().includes(searchText?.toLowerCase()) || locker?.locker_door?.door_no.includes(searchText)
            );
            const filteredLockers = filterAllLockersWithoutReturnedStatus(filtered); 
            const extraFeatureEnabled = filtered?.some(item => item.status ===  PENDING);
            setExtraFeatureEnabled(extraFeatureEnabled);
            setFilteredLockers(filteredLockers);
            if (filtered.length > 0) {
                setHasDataInSearch(true);
            } else {
                setHasDataInSearch(false);
            }
            const returnedLockers = filterLockersWithReturnedStatus(filtered); 
            setHasReturnedLockers( (returnedLockers?.length > 0) ? true : false );
            setReturnFilteredList(returnedLockers);
            devConsoleLog('length local: ', returnedLockers?.length, returnedLockers?.length > 0)
        } catch (error) {
            console.error("MyLockerListPage.js - handleSearchUserInLocal", error)
        }
    }

    /* useEffect #3 (declared third; runs after #2 when triggered) - search + initial fetch orchestration
        - Trigger: whenever searchText changes.
        - When assignment pricing is enabled:
            - Runs only once (guarded by isInitialGetAssignedLockersDoneRef).
            - Calls getAssignedLockersAndCheckPaymentStatus() to load assigned lockers.
        - When assignment pricing is NOT enabled:
            - If searchText changed (via prevSearchTextRef):
            - Resets all locker-related lists and flags.
            - If searchText length > 2:
                - Uses debouncedGetLockerInfo(searchText) when server-side pagination is needed.
                - Otherwise searches locally via handleSearchUserInLocal().
            - If searchText length === 0:
                - Resets page/search flags and fetches default list with getLockerInfo().
            - Updates prevSearchTextRef to the latest searchText.
        - State updated (indirectly via called functions):
            - lockerList, filteredLockers, returnedLockersList, hasReturnedLockers,
            hasDataInSearch, isSearchComplete, page, hasMore, nextPageUrl, count, etc.
    */
    useEffect(() => {
        if (isAssignmentPricingEnabled) {
            if ( !isInitialGetAssignedLockersDoneRef.current ) {
                isInitialGetAssignedLockersDoneRef.current = true;
                devConsoleLog('Assignment pricing enabled: luggage locker functionality');
                getAssignedLockersAndCheckPaymentStatus();
            }
            const userDetailsFromStorage = getSecureItemFromSpecificStorage(LOCAL_STORAGE,USER_INFO);
            const username = userDetailsFromStorage?.first_name;
            const assignmentName = settings?.name;
            if (!username || !assignmentName) return;
            const isEligible = isUserEligibleForAssignment(username, assignmentName);
          
            if (isEligible && isUserDetailsDialogShown()) {
                setUserDetails(getStoredUserDetails());
                setIsUserDetailsDialogOpen(true);
              
            }else{
                setIsUserDetailsDialogOpen(false);
                markUserDetailsDialogNotShown();
            }
        }
        else {
            if (prevSearchTextRef.current !== searchText) {
                resetAllLockerRelatedInfoInBetweenSearches();
                setHasReturnedLockers(false);
                if (searchText.length > 2) {
                    if(count > itemPerPage){
                        debouncedGetLockerInfo(searchText);
                    }else{
                        handleSearchUserInLocal();
                    }
                } else if (searchText.length === 0) {
                    setPage(1)
                    setIsSearchComplete(false);
                    setHasDataInSearch(false);
                    getLockerInfo();
                }
                prevSearchTextRef.current = searchText;
            }
        }
    }, [isAssignmentPricingEnabled,settings?.name, searchText]);

    /**
     * Handles the scroll event and loads more locker information if there is more data available.
     */
    const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            if (hasMoreRef.current) {
                const nextPage = extractPageNumber(nextPageUrlRef.current);
                setPage(nextPage);
                pageRef.current = nextPage
                getLockerInfo(searchText, nextPage);
            }
        }
    };

    const debouncedHandleScroll = useCallback(debounce(handleScroll, 200), []);

        /* useEffect #4 (declared fourth; runs after #3 when triggered) - scroll listener + latest refs
            - Trigger: whenever debouncedHandleScroll, hasMore, nextPageUrl, or page changes.
            - Keeps refs in sync so the scroll handler always reads latest values.
            - Attaches a debounced scroll listener to the scroll container.
            - Cleanup: removes the listener on dependency change or unmount.
            - State updated: none directly here (only refs and event listeners).
        */
      useEffect(() => {
        hasMoreRef.current = hasMore;
        nextPageUrlRef.current = nextPageUrl;
        pageRef.current = page;
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', debouncedHandleScroll);
        }
        return () => {
          if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', debouncedHandleScroll);
          }
        };
      }, [debouncedHandleScroll,hasMore, nextPageUrl,page]);
    

    const navigateToScanBarCode = () => {
        history.push('/new-reserve-locker', {scan_barcode: true,hasPendingLockers});
    };

    const navigateToScanQRCode = () => {
        history.push('/new-reserve-locker', {scan_qr_code: true, scan_barcode: true, hasPendingLockers});
    };

    const Locker = ({ item, ListType,isReturnAndDropOff }) => {
        if (isAssignmentPricingEnabled) {
            const isSelectedBookingSlotAvailableForLocker = item?.selected_size_pricing?.id ? true : false;
            const isPaymentPendingWhenSelectedBookingSlotIsAvailable = (item?.status === 'pending') ? true : false;
            const shouldShowPricingTimerCount = hasLockerTimingCount(item);
            const shouldHideButtonsView = !shouldShowPricingTimerCount || !isSelectedBookingSlotAvailableForLocker;

            if (isSelectedBookingSlotAvailableForLocker && isPaymentPendingWhenSelectedBookingSlotIsAvailable) {
                return (
                    <></>
                );
            }
            else {
                return (
                    <LockerItemWithDetails
                        item={item}
                        className='locker-item'
                        usecase={settings.usecase}
                        settings={settings}
                        showBookingDateAndTime={shouldShowPricingTimerCount}
                        showOpenAndCheckoutButtons={true}
                        hideButtonsView={shouldHideButtonsView}
                        isLockerAccordionExpanded={isLockerAccordionExpanded(item)}
                        onLockerAccordionStateToggle={() => toggleLockerAccordionState(item)}
                        LoadersetOFF={LoadersetOFF}
                        openAndCheckoutButtonsHandler={openAndCheckoutButtonsHandler}
                        setLoader={setLoaderDisabled}
                        isLockerOpening={isLoading}
                        setLoaderMessage={setLoadingMessage}
                    />
                );
            }
        }
        else {
            return (
                <LockerItemWithDetails
                    item={item}
                    className='locker-item'
                    usecase={settings.usecase}
                    isLockerAccordionExpanded={expandedLockerRefId === item.ref_id}
                    onLockerAccordionStateToggle={() => toggleLockerAccordionState(item)}
                    ListType={ListType}
                    LoadersetOFF={LoadersetOFF}
                    openAndCheckoutButtonsHandler={openAndCheckoutButtonsHandler}
                    initiateCodPayment={initiateCodPayment}
                    isReturnAndDropOff={isReturnAndDropOff}
                    setLoader={setLoaderDisabled}
                    isLockerOpening={isLoading}
                    setLoaderMessage={setLoadingMessage}
                    hasPendingLockers={hasPendingLockers}
                    returnedLockers={returnedLockersList}
                />
            );
        }
    };


    const handleSearchText = (e) => {
        setSearchText(e.target.value.trim())
    }

    const openAndCheckoutButtonsHandler = (isWithCheckout, lockerItem) => {
        setIsOpenWithCheckoutButtonClicked(isWithCheckout);
        if ((lockerItem?.isOverstay) && (lockerItem.overstayDurationInMilliseconds > gracePeriodInMilliseconds)) {
            showOverstayPaymentConfirmationModal(isWithCheckout, lockerItem);
        }
        else {
            openWithAndWithoutCheckout(isWithCheckout, lockerItem);
        }
    }

    const showOverstayPaymentConfirmationModal = (isWithCheckout, lockerItem) => {
        const amountToBePaid = calculateOverstayAmount(lockerItem);
        setAmountToBePaidForOverstay(amountToBePaid);
        setSelectedLockerItemForOverstayPayment(lockerItem);
        setIsOpenWithCheckoutAfterOverstayPayment(isWithCheckout);
        setIsOverstayPaymentModalVisible(true);
    }

    const calculateOverstayAmount = (lockerItem) => {
        const totalUsageTimeInMilliseconds = lockerItem.totalUsageTimeInMilliseconds;
        const selectedBookingSlotDetails = lockerItem.selected_size_pricing;
        const amountAlreadyPaid = lockerItem.totalAmountPaid;
        let amountToBePaid = 0;
        const selectedDurationInMilliseconds = convertDurationStringToMilliseconds(selectedBookingSlotDetails.duration);
        lockerItem.size_pricing.forEach((slot) => {
            slot.durationInMilliseconds = convertDurationStringToMilliseconds(slot.duration);
        });

        const incrementallySortedBookingSlots = lockerItem?.size_pricing?.slice().sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
        const maxDurationBookingSlot = incrementallySortedBookingSlots[incrementallySortedBookingSlots.length - 1];
        let bookingSlotToConsiderForOverstay;
        const getCurrentSlotOverstayOption = () => {
            const bookingSlot = incrementallySortedBookingSlots.find(
                    (slot) => selectedDurationInMilliseconds === slot.durationInMilliseconds
                );
            const extraUsage = totalUsageTimeInMilliseconds - gracePeriodInMilliseconds;
            const totalBlocks = Math.ceil(extraUsage / selectedDurationInMilliseconds);
            const totalAmount = totalBlocks * parseFloat(bookingSlot?.price || 0);
            const nextAmountToBePaid = totalAmount - amountAlreadyPaid;

            return {
                method: CURRENT_SLOT,
                amountToBePaid: Math.max(Math.round(nextAmountToBePaid), 0),
                bookingSlot
            };
        };
        const getDifferentialOverstayOption = () => {
            if (totalUsageTimeInMilliseconds > (maxDurationBookingSlot.durationInMilliseconds)) {
                const totalNumberOfMaxDurationSlotsToConsider = Math.floor(totalUsageTimeInMilliseconds / maxDurationBookingSlot.durationInMilliseconds);
                const extraDurationBeyondAllMaxDurationsConsidered = totalUsageTimeInMilliseconds % maxDurationBookingSlot.durationInMilliseconds;
                const bookingSlotForExtraDuration = extraDurationBeyondAllMaxDurationsConsidered > 0
                    ? incrementallySortedBookingSlots.find((slot) => extraDurationBeyondAllMaxDurationsConsidered < (slot.durationInMilliseconds + gracePeriodInMilliseconds))
                    : null;
                const totalAmountToCoverUsage = (totalNumberOfMaxDurationSlotsToConsider * parseFloat(maxDurationBookingSlot.price || 0))
                    + parseFloat(bookingSlotForExtraDuration?.price || 0);

                return {
                    method: DIFFERENTIAL,
                    amountToBePaid: Math.max(Math.round(totalAmountToCoverUsage - parseFloat(amountAlreadyPaid)), 0),
                    bookingSlot: bookingSlotForExtraDuration || maxDurationBookingSlot
                };
            }

            const bookingSlot = incrementallySortedBookingSlots.find((slot) => totalUsageTimeInMilliseconds < (slot.durationInMilliseconds + gracePeriodInMilliseconds));
            return {
                method: DIFFERENTIAL,
                amountToBePaid: Math.max(Math.round(parseFloat(bookingSlot?.price || 0) - parseFloat(amountAlreadyPaid)), 0),
                bookingSlot
            };
        };
        const getHourlyOverstayOption = () => {
            const {
                hourlyPriceObjectForSelectedSize,
                hourlyPriceForSelectedSize,
                hourlyDurationInMilliseconds
            } = getHourlyOverstayPricingDetails(lockerItem);

            if (!hourlyPriceForSelectedSize || !hourlyDurationInMilliseconds) {
                return {
                    method: HOURLY,
                    amountToBePaid,
                    bookingSlot: hourlyPriceObjectForSelectedSize
                };
            }

            const overstayDurationInMilliseconds = lockerItem.overstayDurationInMilliseconds ?? Math.max(totalUsageTimeInMilliseconds - selectedDurationInMilliseconds, 0);
            const billableOverstayDurationInMilliseconds = overstayDurationInMilliseconds;
            const totalHourlyBlocksToCharge = Math.ceil(billableOverstayDurationInMilliseconds / hourlyDurationInMilliseconds);
            const totalOverstayAmount = totalHourlyBlocksToCharge * hourlyPriceForSelectedSize;

            return {
                method: HOURLY,
                amountToBePaid: Math.max(Math.round(totalOverstayAmount), 0),
                bookingSlot: hourlyPriceObjectForSelectedSize
            };
        };
        const getLowestOverstayOption = () => {
            const overstayOptions = [
                getCurrentSlotOverstayOption(),
                getDifferentialOverstayOption(),
                getHourlyOverstayOption()
            ];

            overstayOptions.forEach((option) => {
                devConsoleLog(`${option.method} amountToBePaid: `, option.amountToBePaid);
            });

            const validOverstayOptions = overstayOptions.filter((option) => option.bookingSlot && Number.isFinite(option.amountToBePaid) && option.amountToBePaid > 0);

            return validOverstayOptions.sort((firstOption, secondOption) => firstOption.amountToBePaid - secondOption.amountToBePaid)[0] || {
                method: LOWEST_PAYMENT,
                amountToBePaid: 0,
                bookingSlot: null
            };
        };

        if(overdue_pay_method === CURRENT_SLOT){
            const currentSlotOverstayOption = getCurrentSlotOverstayOption();
            bookingSlotToConsiderForOverstay = currentSlotOverstayOption.bookingSlot;
            amountToBePaid = currentSlotOverstayOption.amountToBePaid;
            setSelectedBookingSlotForOverstayPayment(bookingSlotToConsiderForOverstay);
            setSelectedOverduePayMethodForPayment(currentSlotOverstayOption.method);
            return amountToBePaid;
        }
        else if(overdue_pay_method === DIFFERENTIAL){
            const differentialOverstayOption = getDifferentialOverstayOption();
            bookingSlotToConsiderForOverstay = differentialOverstayOption.bookingSlot;
            amountToBePaid = differentialOverstayOption.amountToBePaid;
            setSelectedBookingSlotForOverstayPayment(bookingSlotToConsiderForOverstay);
            setSelectedOverduePayMethodForPayment(differentialOverstayOption.method);
            return amountToBePaid;
        }
        else if(overdue_pay_method === HOURLY){
            const hourlyOverstayOption = getHourlyOverstayOption();
            amountToBePaid = hourlyOverstayOption.amountToBePaid;
            setSelectedBookingSlotForOverstayPayment(hourlyOverstayOption.bookingSlot);
            setSelectedOverduePayMethodForPayment(hourlyOverstayOption.method);
            return amountToBePaid;
        }
        else if(overdue_pay_method === LOWEST_PAYMENT){
            const lowestOverstayOption = getLowestOverstayOption();
            amountToBePaid = lowestOverstayOption.amountToBePaid;
            setSelectedBookingSlotForOverstayPayment(lowestOverstayOption.bookingSlot);
            setSelectedOverduePayMethodForPayment(lowestOverstayOption.method);
            return amountToBePaid;
        }
    }

    /**
     * Calculates the latest locker usage duration from assignment time.
     *
     * The interval state updates once per second and can be stale at the exact moment
     * the user confirms an overstay payment. Recomputing from `assigned_date` ensures
     * the overdue reference is created from the latest available time.
     *
     * @param {Object} lockerItem Selected locker item.
     * @returns {number} Total usage duration in milliseconds.
     */
    const getLatestTotalUsageTimeInMilliseconds = (lockerItem) => {
        const assignedDateAndTime = moment(lockerItem?.assigned_date);

        if (assignedDateAndTime.isValid()) {
            return Math.max(moment().diff(assignedDateAndTime), 0);
        }

        return Math.max(lockerItem?.totalUsageTimeInMilliseconds || 0, 0);
    };

    /**
     * Calculates the duration that should be sent as `overdue_ref`.
     *
     * The returned duration is the total covered time from assignment, rounded according
     * to the selected overstay policy:
     * - current_slot: rounds usage up by the originally selected slot duration.
     * - differential: covers usage using the largest slab plus the smallest fitting slab.
     * - hourly: rounds usage up by the configured hourly overdue block.
     *
     * @param {Object} lockerItem Selected locker item.
     * @param {string} overduePaymentType Resolved overdue payment type.
     * @returns {number} Rounded total covered duration in milliseconds.
     */
    const getOverdueRefDurationInMilliseconds = (lockerItem, overduePaymentType) => {
        const totalUsageTimeInMilliseconds = getLatestTotalUsageTimeInMilliseconds(lockerItem);
        const sizePricing = Array.isArray(lockerItem?.size_pricing) ? lockerItem.size_pricing : [];
        const incrementallySortedBookingSlots = sizePricing
            .map((slot) => ({
                ...slot,
                durationInMilliseconds: slot.durationInMilliseconds || convertDurationStringToMilliseconds(slot.duration)
            }))
            .sort((a, b) => a.durationInMilliseconds - b.durationInMilliseconds);
        const maxDurationBookingSlot = incrementallySortedBookingSlots[incrementallySortedBookingSlots.length - 1];

        if (overduePaymentType === CURRENT_SLOT) {
            const selectedDurationInMilliseconds = convertDurationStringToMilliseconds(lockerItem?.selected_size_pricing?.duration);

            return selectedDurationInMilliseconds
                ? Math.ceil(totalUsageTimeInMilliseconds / selectedDurationInMilliseconds) * selectedDurationInMilliseconds
                : totalUsageTimeInMilliseconds;
        }

        if (overduePaymentType === DIFFERENTIAL) {
            if (!maxDurationBookingSlot?.durationInMilliseconds) {
                return totalUsageTimeInMilliseconds;
            }

            if (totalUsageTimeInMilliseconds > maxDurationBookingSlot.durationInMilliseconds) {
                const totalNumberOfMaxDurationSlotsToConsider = Math.floor(totalUsageTimeInMilliseconds / maxDurationBookingSlot.durationInMilliseconds);
                const extraDurationBeyondAllMaxDurationsConsidered = totalUsageTimeInMilliseconds % maxDurationBookingSlot.durationInMilliseconds;
                const bookingSlotForExtraDuration = extraDurationBeyondAllMaxDurationsConsidered > 0
                    ? incrementallySortedBookingSlots.find((slot) => extraDurationBeyondAllMaxDurationsConsidered < (slot.durationInMilliseconds + gracePeriodInMilliseconds))
                    : null;

                return (totalNumberOfMaxDurationSlotsToConsider * maxDurationBookingSlot.durationInMilliseconds)
                    + (bookingSlotForExtraDuration?.durationInMilliseconds || 0);
            }

            const bookingSlot = incrementallySortedBookingSlots.find((slot) => totalUsageTimeInMilliseconds < (slot.durationInMilliseconds + gracePeriodInMilliseconds));

            return bookingSlot?.durationInMilliseconds || maxDurationBookingSlot.durationInMilliseconds;
        }

        if (overduePaymentType === HOURLY) {
            const { hourlyDurationInMilliseconds } = getHourlyOverstayPricingDetails(lockerItem);

            return hourlyDurationInMilliseconds
                ? Math.ceil(totalUsageTimeInMilliseconds / hourlyDurationInMilliseconds) * hourlyDurationInMilliseconds
                : totalUsageTimeInMilliseconds;
        }

        return totalUsageTimeInMilliseconds;
    };

    /**
     * Builds the overdue reference value for the API payload.
     *
     * The API expects a duration string, for example "5:00:00", rather than decimal
     * hours. The value represents the rounded total covered duration from assignment.
     *
     * @param {Object} lockerItem Selected locker item.
     * @param {string} overduePaymentType Resolved overdue payment type.
     * @returns {string} Duration string formatted as total hours, minutes, and seconds.
     */
    const getOverdueRef = (lockerItem, overduePaymentType) => {
        const overdueRefDurationInMilliseconds = getOverdueRefDurationInMilliseconds(lockerItem, overduePaymentType);

        return convertMillisecondsToSpecifiedTimeFormat(overdueRefDurationInMilliseconds, HH_mm_ss);
    };

    const formatOverstayAmount = (amount) => {
        const currencyCode = overstayPaymentBreakdown?.currencyCode || selectedLockerItemForOverstayPayment?.assignment?.payment_gateway?.[0]?.currency || 'INR';
        const currencySymbol = getSymbolFromCurrency(currencyCode);
        const parsedAmount = Number(amount || 0).toFixed(2);

        return currencySymbol ? `${currencySymbol} ${parsedAmount}` : parsedAmount;
    };

    const renderOverstayPaymentModalContent = () => {
        const currencyCode = overstayPaymentBreakdown?.currencyCode || selectedLockerItemForOverstayPayment?.assignment?.payment_gateway?.[0]?.currency || 'INR';
        const {
            baseAmount = 0,
            totalAmount = 0,
            cgstAmount = 0,
            sgstAmount = 0,
            igstAmount = 0,
            isStateGst = false,
            collectGst = false,
        } = overstayPaymentBreakdown;

        return (
            <Box className='modal-content overstay-payment-content'>
  <Typography className='overstay-description'>
    {t('Overstay_Paragraph', getUnitLabelParams(selectedLockerItemForOverstayPayment?.locker_bank?.bank_type, t))}
  </Typography>

  <Box className='price-breakdown-card'>

    <Box className='divider' />
    <Box className='row subtotal'>
      <Typography className='label'>{`Price (${getSymbolFromCurrency(currencyCode)})`}</Typography>
      <Typography className='value'>
        {formatOverstayAmount(baseAmount)}
      </Typography>
    </Box>
    {collectGst && isStateGst && (
      <>
        <Box className='row tax'>
          <Typography className='label'>
            {`CGST (${Number(settings?.cgst_rate || 0).toFixed(2)}%)`}
          </Typography>
          <Typography className='value'>
            {formatOverstayAmount(cgstAmount)}
          </Typography>
        </Box>

        <Box className='row tax'>
          <Typography className='label'>
            {`SGST (${Number(settings?.sgst_rate || 0).toFixed(2)}%)`}
          </Typography>
          <Typography className='value'>
            {formatOverstayAmount(sgstAmount)}
          </Typography>
        </Box>
      </>
    )}

    {collectGst && !isStateGst && (
      <Box className='row tax'>
        <Typography className='label'>
          {`IGST (${Number(settings?.igst_rate || 0).toFixed(2)}%)`}
        </Typography>
        <Typography className='value'>
          {formatOverstayAmount(igstAmount)}
        </Typography>
      </Box>
    )}

    <Box className='divider total-divider' />

    <Box className='row total'>
      <Typography className='label'>Total payable</Typography>
      <Typography className='value total-price'>
        {formatOverstayAmount(totalAmount)}
      </Typography>
    </Box>
  </Box>
</Box>
        );
    }

    const buildOverstayPaymentDetails = useCallback(async (baseAmount) => {
        const parsedBaseAmount = Number(baseAmount || 0);
        const collectGst = settings?.collect_gst || false;
        const currencyCode = selectedLockerItemForOverstayPayment?.assignment?.payment_gateway?.[0]?.currency || 'INR';

        if (!collectGst) {
            return buildFinalGSTObject(parsedBaseAmount, {
                collectGst,
                currencyCode,
            });
        }

        let isStateGst = selectedLockerItemForOverstayPayment?.locker_bank?.is_state_gst;
        const selectedLockerBankId = selectedLockerItemForOverstayPayment?.locker_bank?.id || lockerBankInfo?.id || lockerBankId;

        if (typeof isStateGst !== 'boolean' && selectedLockerBankId) {
            try {
                const response = await getTenantAndAssignmentSettings(selectedLockerBankId);
                if (response?.status === SUCCESS) {
                    isStateGst = !!response?.data?.locker_bank?.is_state_gst;
                }
            } catch (error) {
                console.error('Error fetching GST settings for overstay payment: ', error);
            }
        }

        return buildFinalGSTObject(parsedBaseAmount, {
            collectGst,
            isStateGst: !!isStateGst,
            cgstRate: Number(settings?.cgst_rate || 0),
            sgstRate: Number(settings?.sgst_rate || 0),
            igstRate: Number(settings?.igst_rate || 0),
            currencyCode,
        });
    }, [
        lockerBankId,
        lockerBankInfo?.id,
        selectedLockerItemForOverstayPayment?.assignment?.payment_gateway,
        selectedLockerItemForOverstayPayment?.locker_bank?.id,
        selectedLockerItemForOverstayPayment?.locker_bank?.is_state_gst,
        settings?.collect_gst,
        settings?.cgst_rate,
        settings?.sgst_rate,
        settings?.igst_rate
    ]);

    useEffect(() => {
        let isActive = true;

        const loadOverstayPaymentBreakdown = async () => {
            if (!isOverstayPaymentModalVisible) {
                return;
            }

            const { paymentBreakdown } = await buildOverstayPaymentDetails(amountToBePaidForOverstay);

            if (isActive && paymentBreakdown) {
                setOverstayPaymentBreakdown(paymentBreakdown);
            }
        };

        loadOverstayPaymentBreakdown();

        return () => {
            isActive = false;
        };
    }, [
        amountToBePaidForOverstay,
        buildOverstayPaymentDetails,
        isOverstayPaymentModalVisible
    ]);

    const makeOverstayPaymentAndThenAccessLocker = async () => {
        
        setLoadingMessage(t('initiating_transaction_please_wait'));
        setLoaderDisabled(true);

        try {
            const overduePaymentType = overdue_pay_method === LOWEST_PAYMENT
                ? selectedOverduePayMethodForPayment
                : overdue_pay_method;
            const overdueRef = getOverdueRef(selectedLockerItemForOverstayPayment, overduePaymentType);
            const overduePaymentResponse = await overduePayment(selectedLockerItemForOverstayPayment.ref_id, amountToBePaidForOverstay , overduePaymentType, 'OVERDUE', overdueRef);
           
            if (overduePaymentResponse?.status === SUCCESS) {
                const { finalGSTObject } = await buildOverstayPaymentDetails(overduePaymentResponse?.data?.amount);
                const overstayPrePaymentRegistrationResponse = await makeOverstayPrePaymentRegistration(overduePaymentResponse, finalGSTObject);
                if (overstayPrePaymentRegistrationResponse?.status === SUCCESS) {
                    if (isOpenWithCheckoutAfterOverstayPayment) {
                        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_IS_OPEN_WITH_CHECKOUT_AFTER_OVERSTAY_PAYMENT, true);
                    }

                    if (overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway === 'stripe') {
                        const lockerUnitDetails = selectedLockerItemForOverstayPayment;
                        const newPaymentRecord = {
                            payment_gateway: overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway,
                            payment_gateway_reference: overstayPrePaymentRegistrationResponse?.data?.data?.payment_id,
                            transaction_id: overstayPrePaymentRegistrationResponse?.data?.data?.transaction_id
                        };
                        lockerUnitDetails.payment_records.unshift(newPaymentRecord);

                        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_IS_REDIRECTED_FROM_STRIPE_PAYMENT_GATEWAY, true);
                        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PROP_LOCKER_UNIT_DETAILS, lockerUnitDetails);

                        window.location.href = overstayPrePaymentRegistrationResponse?.data?.data?.field_1;
                        return;
                    }

                    if ( !arePaymentGatewayAndAccessKeyValid(overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway, overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway_reference) ) {
                        return;
                    }

                    const lockerData = {
                        reservedLocker: selectedLockerItemForOverstayPayment,
                        locker_bank: {
                            name: selectedLockerItemForOverstayPayment.locker_bank.name,
                            location: {
                                name: selectedLockerItemForOverstayPayment.locker_bank.location.name
                            }
                        },
                        assignment: {
                            payment_gateway: selectedLockerItemForOverstayPayment.assignment.payment_gateway
                        },
                        payment_records: [
                            { amount: overstayPrePaymentRegistrationResponse?.data?.data?.amount }
                        ],
                        user: {
                            username: '',
                            email: selectedLockerItemForOverstayPayment.user.email,
                            mobile_number: selectedLockerItemForOverstayPayment.user.mobile_number
                        }
                    };
                
                    storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway);
                    storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, overstayPrePaymentRegistrationResponse?.data?.data?.payment_gateway_reference);

                    setLoaderDisabled(false);
                    history.push({
                        pathname: getPathForNextPage(LOCKER_SIZE_SELECTION, PAYMENT_GATEWAY),
                        state: {
                            lockerUnitDetails: selectedLockerItemForOverstayPayment,
                            lockerData,
                            currentReferenceId: overstayPrePaymentRegistrationResponse?.data?.data?.transaction_id,
                            isOverstayPayment: true,
                            selectedBookingSlotForOverstayPayment,
                            isOpenWithCheckoutButtonClicked
                        }
                    })
                }
            }
        } catch (error) {
            setLoaderDisabled(false);
            console.error('Error during overdue payment: ', error);
        }
    };

    const makeOverstayPrePaymentRegistration = async (overduePaymentResponse, finalGSTObject = {}) => {
        try {
            const body = {
                "payment_reference_id": overduePaymentResponse?.data?.transaction_id,
                "payment_gateway": overduePaymentResponse?.data?.payment_gateway,
                "locker_bank_id": selectedLockerItemForOverstayPayment?.locker_bank.id,
                "locker_door_number": selectedLockerItemForOverstayPayment?.locker_door.door_no,
                "base_amount": Number(overduePaymentResponse?.data?.amount || 0),
                "currency": overduePaymentResponse?.data?.currency,
                "payment_mode": overduePaymentResponse?.data?.payment_mode,
                ...finalGSTObject,
                "door_size_payment_slab": selectedBookingSlotForOverstayPayment ? selectedBookingSlotForOverstayPayment.id : null
            };

            if (overduePaymentResponse?.data?.payment_gateway === 'stripe') {
                body.success_url = `${window.location.protocol}//${window.location.host}/swipe-to-open`;
                body.cancel_url = `${window.location.protocol}//${window.location.host}/home-screen`;
            }

            return await prePaymentRegistration(body);
        } catch (error) {
            console.error('Error while initiating payment for overstay: ', error);
        }
    };

    const openWithAndWithoutCheckout = async (withCheckout, lockerItem) => {
        setLoadingMessage(t('opening_locker_please_wait', getUnitLabelParams(lockerItem?.locker_bank?.bank_type, t)));
        setLoaderDisabled(true);

        if (settings?.is_geofencing) {
            const lockerBankLatitude = lockerItem?.locker_bank?.latitude ? parseFloat(lockerItem?.locker_bank?.latitude) : null;
            const lockerBankLongitude = lockerItem?.locker_bank?.longitude ? parseFloat(lockerItem?.locker_bank?.longitude) : null;
            const maxAllowedDistanceInMeters = settings?.geofencing_radius;
            const isUserNearbyLockerBank = await verifyUserProximity({latitude: lockerBankLatitude, longitude: lockerBankLongitude}, maxAllowedDistanceInMeters);
            devConsoleLog('is user nearby locker bank: ', isUserNearbyLockerBank);

            if ( !isUserNearbyLockerBank.isNearby ) {
                setLoadingMessage('');
                setLoaderDisabled(false);
                setUserProximityError(isUserNearbyLockerBank.message);
                setIsUserProximityErrorModalVisible(true);

                return;
            }
        }

        try {
            const openLockerResponse = await openLocker(lockerItem?.ref_id);
            if (openLockerResponse.status === SUCCESS) {
                if (withCheckout) {
                    setLoadingMessage(t('checkoutInProgress'));
                    const releaseLockerResponse = await releaseLockerOfPickUpUser(lockerItem?.ref_id);

                    if (releaseLockerResponse.status === SUCCESS) {
                        ShowToast(releaseLockerResponse.message, TOAST_SUCCESS);
                    }
                }
                else {
                    ShowToast(openLockerResponse.message, TOAST_SUCCESS);
                }

                setLoaderDisabled(false);

                history.push({
                    pathname: getPathForNextPage(HOME, LOCKER_OPENED),
                    state: {
                        lockerUnitDetails: lockerItem,
                        locker_bank_details: lockerItem.locker_bank,
                        locker_unit_details: lockerItem.locker_door,
                        pickupUserDetails: lockerItem.user,
                        clientRef: lockerItem.client_ref,
                        assignTime: lockerItem.assigned_date,
                        hasPendingLockers: hasPendingLockers,
                        isOpened: true,
                        status: lockerItem.status,
                        is_already_opened_once: withCheckout ? false : true,
                        ref_id: lockerItem?.ref_id
                    }
                });
            }
        }
        catch (error) {
            setLoaderDisabled(false);
            console.error('Error: ', error);
        }
    }

    const initiateCodPayment = async (lockerItem) => {
        setLoadingMessage(t('initiating_transaction_please_wait'));
        setLoaderDisabled(true);

        let paymentRecordToUseToInitiateCodPayment = lockerItem.payment_records[0];

        if (paymentRecordToUseToInitiateCodPayment.status === 'failed') {
            devConsoleLog('Previous payment failed. Creating new payment record');

            paymentRecordToUseToInitiateCodPayment = await createNewCodPaymentRecordForReAttempt(lockerItem.ref_id, parseFloat(paymentRecordToUseToInitiateCodPayment.amount), 'PAYMENT');

            if (paymentRecordToUseToInitiateCodPayment?.transaction_id) {
                lockerItem.payment_records.unshift(paymentRecordToUseToInitiateCodPayment);
            }
        }

        if (paymentRecordToUseToInitiateCodPayment?.transaction_id) {
            const initiatePaymentResponse = await initiatePayment(lockerItem.locker_bank.id, lockerItem.locker_door.door_no, paymentRecordToUseToInitiateCodPayment.payment_gateway, paymentRecordToUseToInitiateCodPayment.transaction_id, paymentRecordToUseToInitiateCodPayment.amount);

            if (initiatePaymentResponse?.status === SUCCESS && arePaymentGatewayAndAccessKeyValid(initiatePaymentResponse?.data?.data?.payment_gateway, initiatePaymentResponse?.data?.data?.payment_gateway_reference)) {
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, initiatePaymentResponse?.data?.data?.payment_gateway);
                storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, initiatePaymentResponse?.data?.data?.payment_gateway_reference);

                setLoaderDisabled(false);

                history.push({
                    pathname: getPathForNextPage(HOME, PAYMENT_GATEWAY),
                    state: {
                        lockerData: lockerItem,
                        hasPendingLockers: hasPendingLockers,
                        currentReferenceId: paymentRecordToUseToInitiateCodPayment.transaction_id
                    }
                });
            }
            else if (initiatePaymentResponse?.status === SUCCESS) {
                devConsoleLog('Invalid data in initiate payment success response. Reloading page.');
                window.reload();
            }
        }

        setLoaderDisabled(false);
    };

    const createNewCodPaymentRecordForReAttempt = async (lockerReferenceId, amount, paymentType) => {
        try {
            const overduePaymentResponse = await overduePayment(lockerReferenceId, amount, undefined, paymentType);

            if (overduePaymentResponse?.status === SUCCESS) {
                return overduePaymentResponse?.data;
            }
        } catch (error) {
            console.error('Error while re-attempting payment initiation: ', error);
        }
    };

    const initiatePayment = async (lockerBankId, lockerDoorNumber, paymentGateway, paymentReferenceId, amount) => {
        try {
            const body = {
                "locker_bank_id": lockerBankId,
                "locker_door_number": lockerDoorNumber,
                "payment_gateway": paymentGateway,
                "payment_reference_id": paymentReferenceId,
                "amount": amount
            };
            return await prePaymentRegistration(body);
        } catch (error) {
            console.error('Error during pre payment registration: ', error);
        }
    };

    const makePrePaymentRegistration = async (lockerData) => {
        LoadersetON();
        setLoadingMessage(t('initiating_transaction_please_wait'));
        const body = {
            "payment_reference_id": lockerData.payment_records[0].transaction_id,
            "payment_gateway": lockerData.payment_records[0].payment_gateway,
            "locker_bank_id": lockerData.locker_bank.id,
            "locker_door_number": lockerData.payment_records[0].locker_door,
            "amount": lockerData.payment_records[0].amount
        }
        const response = await prePaymentRegistration(body);
        if (response.status === SUCCESS) {
            storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY, lockerData.payment_records[0].payment_gateway);
            storeSecureItemInSpecifiedStorage(SESSION_STORAGE, SS_PAYMENT_GATEWAY_ACCESS_KEY, response.data?.data?.payment_gateway_reference);

            history.push(getPathForNextPage(HOME, PAYMENT_GATEWAY), {
                lockerData: lockerData,
                hasPendingLockers: hasPendingLockers,
                currentReferenceId: lockerData.payment_records[0].transaction_id,
                redirectionPath: "/my-lockers"
            });
            LoadersetOFF();
        }
        else if (response.status === ERROR) {
            ShowToast(t(response.message), TOAST_ERROR);
            LoadersetOFF();
        }
        else if (response.status === REDIRECT) {
            history.push(getPathForNextPage(HOME, HOME), {
                message: t(response.message),
                messageType: TOAST_ERROR
            });
            LoadersetOFF();
        }
    }

    const redirectToMap = (locationDetails = null, lockersData = null) => {
        history.push({
            pathname: '/map',
            state: {
                ...(locationDetails && {
                    center: locationDetails,
                    useUserLocation: true,
                }),
                ...(lockersData && {
                    lockersData,
                    timestamp: Date.now(),
                }),
            },
        });
    };

    const fetchNearbyLockersAndRedirect = async (userLocation) => {
        const { lockersData } = await fetchNearbyLockersForLocation({
            userLocation,
            onLoadingMessage: setLoadingMessage,
        });

        redirectToMap(userLocation, lockersData);
    };

    const handleToMapRedirect = async () => {
        const storedUserLocation = getSecureItemFromSpecificStorage(
            LOCAL_STORAGE,
            USER_LOCATION_DETAILS
        );

        try {
            LoadersetON();

            if (storedUserLocation?.lat && storedUserLocation?.lng) {
                await fetchNearbyLockersAndRedirect(storedUserLocation);
                return;
            }

            setLoadingMessage(t('info_Message_Getting_Location'));
            const userLocation = await getCurrentBrowserLocation();
            await fetchNearbyLockersAndRedirect(userLocation);
        } catch (error) {
            console.error('Location or locker fetch error: ', error);
            ShowToast(getNearbyLockerErrorMessage(error), TOAST_ERROR);
        } finally {
            LoadersetOFF();
        }
    };


    const navigateToScanQRCodeBookNow = () => {
        setShowQRCodeReader(true);
    };


    const reserveLockerButtonHandler =  async () => {
        if (settings.usecase === DYNAMIC_USE_CASE || settings.usecase === LUGGAGE_USE_CASE || (settings?.usecase_settings?.show_drop_btn_pwa?.value )) {
            await GetAvailableLockerSizesAndRedirectUser(lockerBankInfo,lockerBankId,userId,isAssignmentPricingEnabled, history,setLoaderDisabled,setLoadingMessage, setUserProximityError,setIsUserProximityErrorModalVisible);
        }
        else {
            navigateToScanQRCode();
        }
    };

    return (
        <Box className='my-locker-list-page'>
            <Box className='main-container'>
                {isLoading ? (
                    <Box className='main'>
                        <CircularProgressLoader message={loadingMessage} />
                    </Box>
                ) : (
                    <Box className='main'>
                        {active ? (
                            <Box>
                                <Box className='dashicon' component="img" src={isPodBankType(lockerBankInfo?.LockerBankType) ? dashIcon : LockerBankIcon} alt="Dash Icon" />
                                <Typography className='assignText'>{t('Tenat_Inactive')}</Typography>
                            </Box>
                        ) : (
                            <>
                                {(lockerList.length > 0 || originalLockerList.length > 0) ? (
                                    <>
                                        <Box className='search-bar-view'>   
                                        </Box>
                                        <Grid container className="lockergrid" ref={scrollContainerRef}>
                                            {hasReturnedLockers && (
                                                <Box className="badge-view">
                                                    <BadgeComponent badgeContent={1} primaryText={t('pendingPickups')} secondaryText={t('pleaseFinishPickup')} badgeContainer="badge-pink" />
                                                </Box>
                                            )}
                                            {(searchText == '') ? (
                                                <>
                                                    {returnedLockersList.map(item => (
                                                        <Grid item xs={12} key={item.ref_id || item.locker_door?.id}>
                                                            <Locker item={item} ListType={'Assign'} isReturnAndDropOff={false} />
                                                        </Grid>
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    {(returnFilteredList.length > 0) ? (
                                                        <>
                                                            {returnFilteredList.map(item => (
                                                                <Grid item xs={12} key={item.ref_id || item.locker_door?.id}>
                                                                    <Locker item={item} ListType={'Assign'} isReturnAndDropOff={false} />
                                                                </Grid>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {!hasDataInSearch && (
                                                                <Typography className='no-locker-data'>{t('searchNotFound', getUnitLabelParams(lockerBankInfo?.LockerBankType, t))}</Typography> 
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                                
                                            {(hasReturnedLockers && extraFeatureEnabled) && (
                                                <Box className="divider-view">
                                                    <Divider className='divider'/>
                                                    <Box className="badge-view">
                                                        <BadgeComponent badgeContent={2} primaryText={t('dropOff')} badgeContainer="badge-green" />
                                                    </Box>
                                                </Box>
                                            )}
                                            {(searchText == '') ? (
                                                <>
                                                    {lockerList.map(item => (
                                                        <Grid item xs={12} key={item.ref_id || item.locker_door?.id}>
                                                            <Locker item={item} ListType={'Assign'} isReturnAndDropOff={hasReturnedLockers} />
                                                        </Grid>
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    {(filteredLockers.length > 0) ? (
                                                        <>
                                                                    {filteredLockers.map(item => (
                                                                        <Grid item xs={12} key={item.ref_id || item.locker_door?.id}>
                                                                            <Locker item={item} ListType={'Assign'} isReturnAndDropOff={hasReturnedLockers} />
                                                                        </Grid>
                                                                    ))}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {(isSearchComplete && !hasReturnedLockers) && (
                                                                <Typography className='no-locker-data'>{t('searchNotFound', getUnitLabelParams(lockerBankInfo?.LockerBankType, t))}</Typography>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </Grid>
                                        <div className='advance-booking-buttons'>
                                            {( (
                                                (settings?.usecase_settings?.verify_with_qr_code_pwa?.value && extraFeatureEnabled) || 
                                                settings?.usecase_settings?.show_reserve_locker_btn?.value)) 
                                                && (lockerList.length < settings.lockers_allowed) && (
                                                <ButtonComponent handleClick={reserveLockerButtonHandler} title={t('reserveLockerText', getUnitLabelParams(lockerBankInfo?.LockerBankType, t))} />
                                            )}
                                            {isAssignmentPricingEnabled && (
                                                <div className='button-container'>
                                                    <ButtonComponent className="" handleClick={handleToMapRedirect} title={t('book_in_advance')} />
                                                    <ButtonComponent handleClick={() => history.push(getPathForNextPage(HOME, USER_ACCOUNT))} title={t('view_advance_bookings')} />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    <Box className="noAssignedLockerBlock">
                                        <Box className='dashicon' component="img" src={isPodBankType(lockerBankInfo?.LockerBankType) ? dashIcon : LockerBankIcon} alt="Dash Icon" />
                                        <div className='advance-booking-buttons'>
                                          {settings?.usecase_settings?.show_reserve_locker_btn?.value && (
                                            <ButtonComponent handleClick={reserveLockerButtonHandler} title={t('reserveLockerText', getUnitLabelParams(lockerBankInfo?.LockerBankType, t))} />
                                            )}
                                            {isAssignmentPricingEnabled && (
                                                <div className='button-container'>
                                                    <ButtonComponent className="" handleClick={handleToMapRedirect} title={t('book_in_advance')} />
                                                    <ButtonComponent handleClick={() => history.push(getPathForNextPage(HOME, USER_ACCOUNT))} title={t('view_advance_bookings')} />
                                                </div>
                                                )}
                                         </div>
                                     </Box>
                                 )}
                            </>
                        )}
                        <CustomDialog
                            dialogId='overstay-payment-modal'
                            dialogVisible={isOverstayPaymentModalVisible}
                            onClose={() => setIsOverstayPaymentModalVisible(false)}
                            handleCancel={() => setIsOverstayPaymentModalVisible(false)}
                            handleAccept={makeOverstayPaymentAndThenAccessLocker}
                            dialogTitle={t('Overstay_text')}
                            children={renderOverstayPaymentModalContent}
                            buttonOneTitle={t('button_cancel')}
                            buttonTwoTitle={t('button_pay')}
                            buttonProps={{ buttonOne: {type: BUTTON_WARNING}, buttonTwo: {type: BUTTON_PRIMARY}}}
                        />
                        <CustomDialog
                            dialogId='user-proximity-error-modal'
                            dialogVisible={isUserProximityErrorModalVisible}
                            onClose={() => setIsUserProximityErrorModalVisible(false)}
                            handleCancel={() => setIsUserProximityErrorModalVisible(false)}
                            dialogTitle={t('Location_error')}
                            dialogContentText={userProximityError}
                            buttonOneTitle={t('button_ok')}
                            buttonProps={{buttonOne: {type: BUTTON_PRIMARY}}}
                        />
                        <UserDetailsDialog
                            open={isUserDetailsDialogOpen}
                            onClose={handleCloseUserDetailsDialog}
                            userDetails={userDetails}
                            handleChange={handleChangeUserDetails}
                            handleSubmit={handleSubmitUserDetails}
                            error={submitAttempted ? formErrors : {}}
                            />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default MyLockeListPage;
